import { Component } from '@angular/core';

@Component({
  selector: 'app-subscription-with-error',
  templateUrl: './subscription-with-error.component.html',
  styleUrls: ['./subscription-with-error.component.scss']
})
export class SubscriptionWithErrorComponent {

constructor(){
}

}
